import {
  CollectionEntryFragment,
  DefaultErrorFragment,
  FactTableRefFragment,
  MetricsV1MetricState,
  getTypeOrNull,
  isType,
} from '@spotify/confidence-graphql';

import { getMetricStateDisplay } from '../components/MetricStateIndicator/metricStateDisplay';

type EntryResource = NonNullable<CollectionEntryFragment['resource']>;

interface MetricExtensionFields {
  state?: MetricsV1MetricState | null;
  factTable?: FactTableRefFragment | DefaultErrorFragment | null;
}

const isMetricWithExtensions = (
  resource: EntryResource,
): resource is EntryResource & MetricExtensionFields =>
  isType(resource, 'MetricsV1Metric');

export const getMetricState = (resource: EntryResource): string => {
  if (!isMetricWithExtensions(resource) || !resource.state) return '-';
  return getMetricStateDisplay(resource.state).label;
};

export const getMetricFactTable = (resource: EntryResource): string => {
  if (!isMetricWithExtensions(resource)) return '-';
  return getTypeOrNull(resource.factTable)?.displayName ?? '-';
};
